import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { SessionUser } from 'src/shared/session';

import { VANITY_ERROR_MAP } from '../../../../../constants';

import { schema } from './schema';
import type {
	StarterDashboardV2GetVanityUrlQuery,
	StarterDashboardV2GetVanityUrlQueryVariables,
} from './starterDashboardV2GetVanityUrl.graphql';
import { StarterDashboardV2GetVanityUrl } from './starterDashboardV2GetVanityUrl.graphql';

// using this query to determine whether the vanityUrl that the user is creating is valid or not
type GetVanityUrlParams = { customExpression: string; user?: SessionUser };
type GetVanityUrlReturn = { status: 'ok'; message: string };
export async function getVanityUrl(
	{ customExpression, user }: GetVanityUrlParams,
	{ gql: { fetch } }: UtilityContext,
): Promise<GetVanityUrlReturn> {
	// bail out early if the user is not authenticated
	if (!user) throw new Error(VANITY_ERROR_MAP.UNAUTHENTICATED.code);

	// checks url validity
	const parsed = schema.safeParse(customExpression);
	if (!parsed.success) throw parsed.error;

	const { data } = await fetch<StarterDashboardV2GetVanityUrlQuery, StarterDashboardV2GetVanityUrlQueryVariables>({
		query: StarterDashboardV2GetVanityUrl,
		variables: { customExpression },
		rejectOnError: false,
	});

	// if the query returns a vanity url, then we throw an error to indicate it is already taken
	if (data && data.vanityUrl) throw new Error(VANITY_ERROR_MAP.ALREADY_EXISTS.code);

	// otherwise we return an 'ok' status
	return { status: 'ok', message: 'custom expression is not taken' };
}
